import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ACCORDION } from "constants/systemAdmin";

const Accordion = ({ header, panel, expanded }) => {
  const [active, setActive] = useState(expanded);
  const [height, setHeight] = useState("0");

  useEffect(() => {
    setHeight(
      document.querySelector(".accordion").querySelector(":nth-child(2)")
        .clientHeight
    );
  }, []);

  useEffect(() => {
    setActive(expanded);
  }, [expanded]);

  return (
    <div
      className={`accordion ${active ? "active" : ""}`}
      data-testid={ACCORDION}
    >
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        type="button"
        className="header"
        onClick={() => setActive(!active)}
        style={{ height }}
      >
        &nbsp;
      </button>
      {header}
      <div className="panel">{panel}</div>
    </div>
  );
};

export default Accordion;

Accordion.propTypes = {
  header: PropTypes.element.isRequired,
  panel: PropTypes.element.isRequired,
  expanded: PropTypes.bool.isRequired,
};
